module.exports = __webpack_public_path__ + "static/01-35535a786310a6ed6e1c63d358b3beab.jpg";